import {portMonitorAPI} from 'features/port/api/portMonitorAPI';
import {useUpdateMonitorTags} from 'entities/monitor';

export const useUpdatePortMonitorTags = (uuid: string | undefined) => {
    const [updatePortMonitor] = portMonitorAPI.useUpdatePortMonitorMutation();

    return useUpdateMonitorTags(updatePortMonitor, uuid);
};

export default useUpdatePortMonitorTags;
